import React, { useState } from 'react'
import { screenText, extractCheckbox } from '../content/instructions'
import RichText from '../components/RichText'

// Standalone instruction screens (M0 welcome, P0 follow-up welcome).
export default function InstructionStep ({ step, onAdvance, busy }) {
  const text = screenText(step.screen)
  const boxLabel = extractCheckbox(text) || (step.ackRequired ? 'My screen share and camera are on.' : null)
  const [checked, setChecked] = useState(false)
  const gated = !!(boxLabel && (step.ackRequired || step.pledge))
  const canGo = !gated || checked

  return (
    <div className="study-card">
      <RichText text={text} />
      {boxLabel && (
        <label className="study-check">
          <input type="checkbox" checked={checked} onChange={e => setChecked(e.target.checked)} />
          <span>{boxLabel}</span>
        </label>
      )}
      <div className="study-actions">
        <button className="study-btn study-btn--primary" disabled={!canGo || busy} onClick={() => onAdvance({ ack: checked })}>
          {busy ? '…' : 'Continue'}
        </button>
      </div>
    </div>
  )
}
